import React from 'react';
import Header from '../../atoms/Header';
import { Container } from './components';
import CollapsablePlansList from './collapsable-plans-list';
import { eventParamAttributes, } from '@spotify-internal/touchdown-analytics';
const CollapsablePlans = ({ header, data, container, eventParams, }) => {
    return (React.createElement(Container, Object.assign({}, container, eventParamAttributes(eventParams)),
        header && React.createElement(Header, Object.assign({}, header)),
        data &&
            data.map((plan, i) => (React.createElement(CollapsablePlansList, { key: `collapsable-plans-${i}`, plan: plan })))));
};
export default CollapsablePlans;
//# sourceMappingURL=collapsable-plans.js.map